import { render, staticRenderFns } from "./NewNumber.vue?vue&type=template&id=4b448f21&scoped=true"
import script from "./NewNumber.vue?vue&type=script&lang=js"
export * from "./NewNumber.vue?vue&type=script&lang=js"
import style0 from "./NewNumber.vue?vue&type=style&index=0&id=4b448f21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b448f21",
  null
  
)

export default component.exports